import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

import { TestKitsActivationPayload, TestKitsInfo, TestKitsPayload, TestKitsToken } from './index.model'
import { CORE_API_ENTRYPOINT, customHeaders } from '../../services.helpers'

export const testKitsApi = createApi({
  baseQuery: fetchBaseQuery({ baseUrl: '' }),
  endpoints: (builder) => ({
    postActivate: builder.mutation<{ route; }, TestKitsInfo>({ //v1
      query: ({  dateOfBirth, firstName, gender, id, lastName  }) => ({
        body: {
          ...(firstName && { firstName: firstName }),
          ...(lastName && { lastName: lastName }),
          ...(dateOfBirth && { dateOfBirth: dateOfBirth }),
          ...(gender && { gender: gender }),
        },
        headers: customHeaders(),
        method: 'POST',
        url: `${CORE_API_ENTRYPOINT}/api/test_kits/${id}/activate`,
      }),
    }),
    postConfirmEmail: builder.mutation<any, TestKitsToken>({ //v1 + v2 // TODO: add this to the success page
      query: ({  token  }) => ({
        body: {
          ...(token && { token: token }),
        },
        headers: customHeaders(),
        method: 'POST',
        url: `${CORE_API_ENTRYPOINT}/api/test_kits/confirm-email`,//v1 + v2
      }),
    }),
    postRequestActivation: builder.mutation<{ route; }, TestKitsActivationPayload>({ //v2
      query: ({  activationCode, dateOfBirth, email, firstName, gender, lastName  }) => ({
        body: {
          ...(activationCode && { activationCode: activationCode }),
          ...(email && { email: email }),
          ...(firstName && { firstName: firstName }),
          ...(lastName && { lastName: lastName }),
          ...(dateOfBirth && { dateOfBirth: dateOfBirth }),
          ...(gender && { gender: gender }),
        },
        headers: customHeaders(),
        method: 'POST',
        url: `${CORE_API_ENTRYPOINT}/api/test_kits/request-activation`,
      }),
    }),
    postRequestEmailConfirmation: builder.mutation<{ route; }, TestKitsPayload>({ // v1
      query: ({
        activationCode,
        email,
      }) => ({
        body: {
          ...(activationCode && { activationCode: activationCode }),
          ...(email && { email: email }),
        },
        headers: customHeaders(),
        method: 'POST',
        url: `${CORE_API_ENTRYPOINT}/api/test_kits/request-email-confirmation`,
      }),
    }),
  }),
  reducerPath: 'testKitsApi',
})

export const usePostRequestEmailConfirmation = testKitsApi.endpoints.postRequestEmailConfirmation.useMutation
export const usePostConfirmEmail = testKitsApi.endpoints.postConfirmEmail.useMutation
export const usePostActivate = testKitsApi.endpoints.postActivate.useMutation
export const usePostRequestActivation = testKitsApi.endpoints.postRequestActivation.useMutation
